var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 29.5C23.4167 29.5 23.771 29.3543 24.063 29.063C24.355 28.7717 24.5007 28.4173 24.5 28C24.5 27.5833 24.3543 27.2293 24.063 26.938C23.7717 26.6467 23.4173 26.5007 23 26.5C22.5833 26.5 22.2293 26.646 21.938 26.938C21.6467 27.23 21.5007 27.584 21.5 28C21.5 28.4167 21.646 28.771 21.938 29.063C22.23 29.355 22.584 29.5007 23 29.5ZM28 29.5C28.4167 29.5 28.771 29.3543 29.063 29.063C29.355 28.7717 29.5007 28.4173 29.5 28C29.5 27.5833 29.3543 27.2293 29.063 26.938C28.7717 26.6467 28.4173 26.5007 28 26.5C27.5833 26.5 27.2293 26.646 26.938 26.938C26.6467 27.23 26.5007 27.584 26.5 28C26.5 28.4167 26.646 28.771 26.938 29.063C27.23 29.355 27.584 29.5007 28 29.5ZM33 29.5C33.4167 29.5 33.771 29.3543 34.063 29.063C34.355 28.7717 34.5007 28.4173 34.5 28C34.5 27.5833 34.3543 27.2293 34.063 26.938C33.7717 26.6467 33.4173 26.5007 33 26.5C32.5833 26.5 32.2293 26.646 31.938 26.938C31.6467 27.23 31.5007 27.584 31.5 28C31.5 28.4167 31.646 28.771 31.938 29.063C32.23 29.355 32.584 29.5007 33 29.5ZM28 38C26.6167 38 25.3167 37.7373 24.1 37.212C22.8833 36.6867 21.825 35.9743 20.925 35.075C20.025 34.175 19.3127 33.1167 18.788 31.9C18.2633 30.6833 18.0007 29.3833 18 28C18 26.6167 18.2627 25.3167 18.788 24.1C19.3133 22.8833 20.0257 21.825 20.925 20.925C21.825 20.025 22.8833 19.3127 24.1 18.788C25.3167 18.2633 26.6167 18.0007 28 18C29.3833 18 30.6833 18.2627 31.9 18.788C33.1167 19.3133 34.175 20.0257 35.075 20.925C35.975 21.825 36.6877 22.8833 37.213 24.1C37.7383 25.3167 38.0007 26.6167 38 28C38 29.3833 37.7373 30.6833 37.212 31.9C36.6867 33.1167 35.9743 34.175 35.075 35.075C34.175 35.975 33.1167 36.6877 31.9 37.213C30.6833 37.7383 29.3833 38.0007 28 38ZM28 36C30.2333 36 32.125 35.225 33.675 33.675C35.225 32.125 36 30.2333 36 28C36 25.7667 35.225 23.875 33.675 22.325C32.125 20.775 30.2333 20 28 20C25.7667 20 23.875 20.775 22.325 22.325C20.775 23.875 20 25.7667 20 28C20 30.2333 20.775 32.125 22.325 33.675C23.875 35.225 25.7667 36 28 36Z",
    fill: "#D06A11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.dd71426ae348524e1be26283275dd153.svg";
export { ForwardRef as ReactComponent };